import { useState, useEffect } from "react";
import CONSTANTS from "../../Constants/Constants";
import FormErrorCard from "../../components/FormErrorCard";
import { return_country_alpha_option_components } from "../../helpers/world_country_codes";
import { return_calling_option_components } from "../../helpers/country_calling_codes";
import { 
    calculate_age, 
    validateYYYYMMDDInputDates, 
    confirmYYYMMDDDateValidity, 
    add_months_to_date 
} from "../../helpers/general";

const GuestForm = (props) => {
    /*const { resetCheckoutConfirmation } = props;*/

    const [geust, setGuest] = useState(props.guest);
    const [ age, setAge ]=useState(calculate_age(geust.born_on));
    const [ phoneSuffix, setPhoneSuffix ] = useState("");
    const [ phonePrefix, setPhonePrefix ] = useState("");
    const [ formValidation, setFormValidation ] = useState({
        type: "warning",
        isError: false,
        message: "",
        isDateFormat: false,
    });
    let guest_type = geust?.type;
 
    const resetFormValidation = () => {
        setFormValidation({
            type: "warning",
            isError: false,
            message: "",
            isDateFormat: false
        });
    }

    useEffect(()=>{
        //bind_calling_codes("passenger_form_call_code_select");
    });

    const setFirstName = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, given_name: e.target.value});
    }

    const setLastName = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, family_name: e.target.value});
    }

    const setEmail = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, email: e.target.value});
    }
    const setGender = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, gender: e.target.value});
    }
    const setDOB = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, born_on: validateYYYYMMDDInputDates(e.target.value, e.nativeEvent.data)});
    }
    const setTitle = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, title: e.target.value});
    }
    const setCountryCallingCode = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, phone_number: (e.target.value+phoneSuffix)});
        setPhonePrefix(e.target.value);
    }
    const setPhoneNumber = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, phone_number: (phonePrefix+e.target.value)});
        setPhoneSuffix(e.target.value);
    }
    
    const setTravelDocID = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, identity_documents: [
            { ...geust.identity_documents[0], unique_identifier: e.target.value }
        ]});
    }
    const setTravelDocExpiration = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, identity_documents: [
            { ...geust.identity_documents[0], expires_on: validateYYYYMMDDInputDates(e.target.value, e.nativeEvent.data) }
        ]});
    }
    const setTravelDocCountry = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, identity_documents: [
            { ...geust.identity_documents[0], issuing_country_code: e.target.value }
        ]});
    }
    const setTravelDocType = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({...geust, identity_documents: [
            { ...geust.identity_documents[0], type: e.target.value }
        ]});
    }

    const setPassengerAge = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setAge(calculate_age(e.target.value));
    }

    const setInfantPassengerId = (e) => {
        //resetCheckoutConfirmation();
        resetFormValidation();
        setGuest({ ...geust, infant_passenger_id: e.target.value });
    }

    // Search object
    const SEARCH_OBJ=window._getSearchObj();

    const onSubmit = () => {
        if(!confirmYYYMMDDDateValidity(geust.born_on)){
            setFormValidation({
                type: "error",
                isError: true,
                message: "Date of birth is not in correct format",
                isDateFormat: true,
                isDateOfBirthFormat: true,
            });
            return;
        }
        if(!confirmYYYMMDDDateValidity(geust.identity_documents[0].expires_on)){
            setFormValidation({
                type: "error",
                isError: true,
                message: "Document expiration date is not in correct format",
                isDateFormat: true,
                isPassportExpDateFormat: true,
            });
            return;
        }
        
        if((age || age===0) && guest_type){
            if((guest_type.trim()==="adult") 
                && (age < 18)){
                setFormValidation({
                    type: "error",
                    isError: true,
                    message: "Adult passenger must be 18 years and above",
                    isDateFormat: false
                });
                return;
            }
            if((guest_type.trim()==="child") 
                && (age < 2 || age > 17)){
                setFormValidation({
                    type: "error",
                    isError: true,
                    message: "Child passenger must be from 2 to 17 years",
                    isDateFormat: false
                });
                return;
            }
            if((guest_type.trim()==="infant_without_seat") 
                && (age > 1)){
                setFormValidation({
                    type: "error",
                    isError: true,
                    message: "Infant passenger must be less than 2 years",
                    isDateFormat: false
                });
                return;
            }
        }

        // Checking passport expiration date
        const ADDED_MONTHS=2;
        const PASSPORT_VALIDITY_DATE=add_months_to_date(new Date((SEARCH_OBJ?.itinerary?.departure?.date+"T00:00:00")), ADDED_MONTHS);
        const PASSPORT_EXPIRATION_DATE=new Date((geust?.identity_documents[0]?.expires_on+"T00:00:00"));
        if(geust?.identity_documents[0]?.expires_on){
            if(PASSPORT_EXPIRATION_DATE < PASSPORT_VALIDITY_DATE){
                setFormValidation({
                    type: "error",
                    isError: true,
                    message: `Passport must be valid until: ${PASSPORT_VALIDITY_DATE.toISOString().split("T")[0]}`,
                    isDateFormat: false
                });
                return;
            }
        }
        props.savePassengerInfo(geust, props.index)
    }

    return (
        <div style={{width: "calc(100%)"}}>
            <div style={{padding: "10px 0"}}>
                <p style={{color: "rgba(0,0,0,0.7)", textAlign: "center", fontFamily: "'Prompt', Sans-serif", fontSize: 14, padding: 10, paddingTop: 0}}>
                    GUEST DETAILS</p>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-check" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Title</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <select 
                            onChange={setTitle} 
                            value={geust.title}
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}>
                            <option value="">Select here...</option>
                            <option value="Mr">Mr</option>
                            <option value="Ms">Ms</option>
                        </select>
                    </div>
                </div>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa fa-user" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        First Name</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <input 
                            onInput={setFirstName}
                            value={geust.given_name}
                            type="text" placeholder="type here..."  
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}/>
                    </div>
                </div>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa fa-user" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Last Name</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <input 
                            onInput={setLastName}
                            value={geust.family_name}
                            type="text" placeholder="type here..."  
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}/>
                    </div>
                </div>
                <div style={{marginBottom: 5, 
                        backgroundColor: ((formValidation.isError && formValidation.isDateFormat && formValidation?.isDateOfBirthFormat) 
                        ? "rgba(255,0,0,0.2)" : "rgba(0,0,0,0.07)"), padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-calendar" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Birth Date (YYYY-MM-DD)
                        <span style={{fontFamily: "'Prompt', Sans-serif", margin: "0 10px", color: "rgba(0,0,0,0.7)", fontSize: 11}}>
                            &#8226;
                        </span>
                        <span style={{fontSize: 12, color: "rgba(0,0,0,0.6)", fontFamily: "'Prompt', Sans-serif"}}>
                            {(guest_type.trim()==="adult") && "18+ years"}
                            {(guest_type.trim()==="child") && "2 - 17 years"}
                            {(guest_type.trim()==="infant_without_seat") && "0 - 1 year"}
                        </span>
                    </p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <input 
                            onBlur={setPassengerAge}
                            onInput={setDOB}
                            value={geust.born_on}
                            type="text" placeholder="YYYY-MM-DD"  
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}/>
                    </div>
                </div>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-person-half-dress" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Gender</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <select 
                            onChange={setGender} 
                            value={geust.gender}
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}>
                            <option value="">Select here...</option>
                            <option value="m">Male</option>
                            <option value="f">Female</option>
                        </select>
                    </div>
                </div>
                {
                    (geust.born_on && (age > CONSTANTS.infant_age_threshold)) &&
                    <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                        <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                            <i className="fa-solid fa-envelope" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                            Email</p>
                        <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                            <input 
                                onInput={setEmail} 
                                value={geust.email}
                                type="email" placeholder="type here..."
                                style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}/>
                        </div>
                    </div>
                }
                {
                    (geust.born_on && (age >= CONSTANTS.infant_age_threshold)) &&
                    <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                        <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                            <i className="fa-solid fa-mobile" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                            Phone</p>
                        {
                            geust.phone_number &&
                            <p style={{fontFamily: "'Prompt', Sans-serif", fontSize: 13, color: "rgba(0,0,0,0.5)"}}>
                                Phone is set to: {geust.phone_number}</p>
                        }
                        <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                            <select id="passenger_form_call_code_select"
                                onChange={setCountryCallingCode}
                                value={phonePrefix}
                                style={{border: "none", background: "none", padding: 10, width: "90px"}}>
                                    {return_calling_option_components()}
                            </select>
                            <input 
                                onInput={setPhoneNumber}
                                value={phoneSuffix}
                                type="number" placeholder="type here..."  
                                style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", 
                                width: "calc(100% - 100px)", padding: 10, background: "none", border: "none"}}/>
                        </div>
                    </div>
                }
                <p style={{color: "rgba(0,0,0,0.7)", textAlign: "center", fontFamily: "'Prompt', Sans-serif", fontSize: 14, padding: 10, marginTop: 20}}>
                    TRAVEL DOCUMENT</p>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-id-card" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Document Type</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <select 
                            onChange={setTravelDocType} 
                            value={geust.identity_documents[0].type}
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}>
                            <option value="">Select here...</option>
                            <option value="passport">Passport</option>
                        </select>
                    </div>
                </div>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-passport" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Passport/Document ID</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <input 
                            onInput={setTravelDocID}
                            value={geust.identity_documents[0].unique_identifier}
                            type="text" placeholder="type here..."  
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}/>
                    </div>
                </div>
                <div style={{marginBottom: 5, backgroundColor: (formValidation.isError && formValidation.isDateFormat && formValidation?.isPassportExpDateFormat)
                 ? "rgba(255,0,0,0.2)" : "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-calendar" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Document Expiration (YYYY-MM-DD)</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <input 
                            onInput={setTravelDocExpiration}
                            value={geust.identity_documents[0].expires_on}
                            type="text" placeholder="YYYY-MM-DD"  
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}/>
                    </div>
                </div>
                <div style={{marginBottom: 5, backgroundColor: "rgba(0,0,0,0.07)", padding: 10, borderRadius: 8}}>
                    <p style={{color: "rgba(0,0,0,0.7)", fontFamily: "'Prompt', Sans-serif", fontSize: 14}}>
                        <i className="fa-solid fa-id-card" style={{marginRight: 10, color: "rgb(43, 52, 61)"}}></i>
                        Issue Country</p>
                    <div style={{border: "none", borderTop: "1px solid rgba(0,0,0,0.1)", marginTop: 10}}>
                        <select 
                            onChange={setTravelDocCountry} 
                            value={geust.identity_documents[0].issuing_country_code}
                            style={{fontSize: 14, fontFamily: "'Prompt', Sans-serif", width: "calc(100% - 20px)", padding: 10, background: "none", border: "none"}}>
                            <option value="">Select here...</option>
                            {return_country_alpha_option_components()}
                        </select>
                    </div>
                </div>
            </div>
            {
                formValidation.isError && <FormErrorCard 
                    message={formValidation.message} 
                    type={formValidation.type}
                />
            }
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <div style={{width: "calc(50% - 5px)", backgroundColor: "crimson", cursor: "pointer", fontSize: 14, fontFamily: "'Prompt', Sans-serif", padding: 10, borderRadius: 50, textAlign: "center", color: "white", boxShadow: "1px 2px 3px rgba(0,0,0,0.3"}}
                    onClick={props.unSelectPassengerCard}
                >Cancel</div>
                <div style={{width: "calc(50% - 5px)", backgroundColor: "rgb(23, 87, 148)", cursor: "pointer", fontSize: 14, fontFamily: "'Prompt', Sans-serif", padding: 10, borderRadius: 50, textAlign: "center", color: "white", boxShadow: "1px 2px 3px rgba(0,0,0,0.3"}}
                    onClick={onSubmit} 
                >Save</div>
            </div>
        </div>
    )
}

export default GuestForm;